export enum ReportsListTabsEnum {
  GENERATED = 'generated',
  DELETED = 'deleted',
}
